import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';
import config from '../../config';
import moreImg from '../../images/common/more.svg';
import expandImg from '../../images/common/fullscreen.svg';
import contractImg from '../../images/common/fullscreen_exit.svg';
import deleteImg from '../../images/common/trash_can.svg';
import shareImg from '../../images/common/share.svg';
import ColorSF2 from '../../styles/common/ColorSF2';

const { deleteData } = config.customRole.functionAccess;

const AnalysisMain = styled.div`
  width: 100%;
  height: ${props => `${props.isOpen ? 240 : 40}px`};
  background-color: ${ColorSF2.paleBlue};
  display: flex;
  flex-direction: column;
  justify-content: ${props => (props.isOpen ? 'start' : 'flex-start')};
  align-items: ${props => (props.isOpen ? 'center' : 'flex-start')};
`;
const NavigationBar = styled.div`
  width: 100%;
  height: 40px;
  position: relative;
  display: flex;
  align-items: center;
`;
const ButtonArea = styled.div`
  position: absolute;
  right: 0px;
  display: flex;
  align-items: center;
`;
const Button = styled.div`
  margin-right: 15px;
  width: 30px;
  height: 30px;
`;
const CansukeButton = styled.div`
  margin-right: 15px;
  width: 24px;
  height: 24px;
`;
const ButtonImage = styled.img`
  width: 100%;
  height: 100%;
`;
const More = styled.div`
  position: relative;
`;
const MoreList = styled.div`
  position: absolute;
  right: 15px;
  bottom: 34px;
  width: 200px;
  display: flex;
  flex-direction: column;
  background-color: ${ColorSF2.paleBlue};
`;
const MoreItem = styled.div`
  width: 100%;
  height: 40px;
  padding-left: 10px;
  display: flex;
  text-align: left;
  align-items: center;
  border-bottom: 1px ${ColorSF2.mediumGray} solid;
  background-color: ${ColorSF2.paleBlue};
`;

const MediaFooter = ({
  innerRole,
  isOpenAnalysis,
  isOpenMore,
  isMediaWindowed,
  onDownloadUncompressed,
  onUpdateTagsDialog,
  onDelete,
  onRestore,
  onPost,
  onCompleteDelete,
  onToggleAction,
  onToggleResult,
  provider,
}) => {
  const expandImage = isMediaWindowed ? expandImg : contractImg;
  const displayDeleteData = deleteData.indexOf(innerRole) !== -1;
  const isCansuke = provider && provider.isCansuke;
  return (
    <AnalysisMain isOpen={isOpenAnalysis}>
      <NavigationBar>
        <ButtonArea>
          {displayDeleteData && onDelete && !isCansuke && (
            <Button
              className="button"
              id="onDeleteClick"
              role="presentation"
              onClick={() => onDelete()}
            >
              <ButtonImage src={deleteImg} alt="timelineOpenCloseButton" />
            </Button>
          )}
          {displayDeleteData && onCompleteDelete && (
            <Button
              className="button"
              id="onCompleteDeleteClick"
              role="presentation"
              onClick={() => onCompleteDelete()}
            >
              <ButtonImage src={deleteImg} alt="timelineOpenCloseButton" />
            </Button>
          )}
          {isCansuke && (
            <CansukeButton
              className="button"
              id="onPostClick"
              role="presentation"
              onClick={() => onPost()}
            >
              <ButtonImage src={shareImg} alt="timelineOpenCloseButton" />
            </CansukeButton>
          )}
          {!isCansuke && (
            <More>
              {isOpenMore && (
                <MoreList>
                  {onDownloadUncompressed && (
                    <MoreItem
                      className="button"
                      id="onDownloadUncompressedClick"
                      role="presentation"
                      onClick={() => onDownloadUncompressed()}
                    >
                      <FormattedMessage id="media.detail.download.button.title" />
                    </MoreItem>
                  )}
                  {onUpdateTagsDialog && (
                    <MoreItem
                      className="button"
                      id="onUpdateTagsDialogClick"
                      role="presentation"
                      onClick={() => onUpdateTagsDialog()}
                    >
                      <FormattedMessage id="media.detail.updateTags.button.title" />
                    </MoreItem>
                  )}
                  {onRestore && (
                    <MoreItem
                      className="button"
                      id="onRestoreClick"
                      role="presentation"
                      onClick={() => onRestore()}
                    >
                      <FormattedMessage id="media.detail.restore.button.title" />
                    </MoreItem>
                  )}
                </MoreList>
              )}
              <Button
                className="button"
                id="clickToggleAction"
                role="presentation"
                onClick={() => onToggleAction()}
              >
                <ButtonImage src={moreImg} alt="timelineOpenCloseButton" />
              </Button>
            </More>
          )}
          <Button
            className="button"
            id="clickToggleResult"
            role="presentation"
            onClick={() => onToggleResult()}
          >
            <ButtonImage src={expandImage} alt="timelineOpenCloseButton" />
          </Button>
        </ButtonArea>
      </NavigationBar>
    </AnalysisMain>
  );
};

MediaFooter.propTypes = {
  innerRole: PropTypes.number.isRequired,
  isOpenAnalysis: PropTypes.bool.isRequired,
  isOpenMore: PropTypes.bool.isRequired,
  isMediaWindowed: PropTypes.bool.isRequired,
  onDownloadUncompressed: PropTypes.func,
  onUpdateTagsDialog: PropTypes.func,
  onDelete: PropTypes.func,
  onRestore: PropTypes.func,
  onCompleteDelete: PropTypes.func,
  onPost: PropTypes.func,
  onToggleAction: PropTypes.func.isRequired,
  onToggleResult: PropTypes.func.isRequired,
  provider: PropTypes.object.isRequired,
};

MediaFooter.defaultProps = {
  onDownloadUncompressed: null,
  onUpdateTagsDialog: null,
  onDelete: null,
  onRestore: null,
  onCompleteDelete: null,
  onPost: null,
};

export default MediaFooter;
